namespace('compass.tiles');

compass.require('compass.group.ListLoaderWidget');

compass.tiles.ListLoaderTileWidget = compass.defineWidget(function ListLoaderTileWidget(options) {
     var $j = jQuery;
     var d = $j.dom;
     var _settings = options;
     var me = this;

     /* accessibilty structure */
     var accessibilty = {
          TAB_INDEX: 0
     };

     var _openDialog = function(uploadHistory) {
          var listLoaderContainer = d.div();
          var listLoaderWidget = new compass.group.ListLoaderWidget(listLoaderContainer, {
               groupName: _settings.groupName,
               isCutoff: _settings.isCutoff,
               listLoaderAllowed: _settings.listLoaderAllowed,
               commentsAllowed: _settings.commentsAllowed,
               uploadHistory: uploadHistory
          });

          _listLoaderDialog = d.dialog({
               centerOnView: true,
               classes: 'ListLoaderDialog',
               modal: true,
               contents: listLoaderContainer,
               showParent: true,
               disableClicksOutsideModal: true
          });
     };

     this.render = function(widgetElem) {
          widgetElem.append(
               d.div({ className: 'smallTile tile', tabindex: accessibilty.TAB_INDEX},
                    d.h3({ className: 'tileTitle' }, "Group Roster"),
                    d.div({ className: 'tileExplanation','aria-role' : 'button', role : 'button' }, "Review and manage your room details using an Excel spreadsheet.")
               ).activate(function() {
                    me.trigger('ListLoaderWidget.GA', {action: 'Open Dialog'});
                    compass.loading.start();
                    $j.ajax({
                         url: '/uploadHistory',
                         dataType: 'json',
                         success: function(data) {
                              compass.loading.stop();
                              _openDialog(data.uploadHistory || _settings.uploadHistory);
                         },
                         error: function() {
                              compass.loading.stop();
                              _openDialog(_settings.uploadHistory);
                         }
                    });
               })
          );
     };
}, {
     commentsAllowed: true,
     isCutoff: false,
     listLoaderAllowed: true,
     uploadHistory: false,
     WUID: 'DEFAULT',
     widgetName: 'ListLoaderTileWidget'
});